import { defineMessages, useIntl } from 'react-intl';

import { UserCoupleIcon, UserGroupIcon, UserIcon } from '@jsmdg/yoshi';
import styles from './ProductParticipants.module.scss';

type ProductParticipantsProps = {
    readonly maxParticipants: number;
    readonly minParticipants: number;
};

type ParticipantsIconProps = {
    readonly isCouple: boolean;
    readonly isGroup: boolean;
};

const ParticipantsIcon = ({ isCouple, isGroup }: ParticipantsIconProps): JSX.Element => {
    if (isCouple) {
        return <UserCoupleIcon className={styles.icon} />;
    }

    if (isGroup) {
        return <UserGroupIcon className={styles.icon} />;
    }

    return <UserIcon className={styles.icon} />;
};

const messages = defineMessages({
    participantsLabel: {
        defaultMessage: '{participants} {maxCount, plural, one {Person} other {Personen}}',
    },
});

const ProductParticipants = ({
    maxParticipants,
    minParticipants,
}: ProductParticipantsProps): JSX.Element => {
    const intl = useIntl();

    const getParticipantsLabel = (): string => {
        return intl.formatMessage(messages.participantsLabel, {
            participants:
                minParticipants === maxParticipants
                    ? maxParticipants
                    : `${minParticipants}-${maxParticipants}`,
            maxCount: maxParticipants,
        });
    };

    const isCouple = !!(maxParticipants && maxParticipants === 2);
    const isGroup = !!(maxParticipants && maxParticipants > 2);

    return (
        <div className="d-flex align-items-baseline">
            <ParticipantsIcon isCouple={isCouple} isGroup={isGroup} />
            <span>{getParticipantsLabel()}</span>
        </div>
    );
};

export { ProductParticipants };
